import { makeStyles } from '@mui/styles';

export const useStatusCardSmallPlaceholderStyles = makeStyles({
  title: {
    width: '100px',
    height: '16px',
    backgroundColor: 'lightgrey',
    marginBottom: '16px',
    animation: '$pulse 1.5s ease-in alternate infinite'
  },
  subitle: {
    width: '100%',
    maxWidth: '160px',
    height: '16px',
    backgroundColor: 'lightgrey',
    marginBottom: '16px',
    animation: '$pulse 1.5s ease-in alternate infinite'
  },
  count: {
    width: '40px',
    height: '48px',
    backgroundColor: 'lightgrey',
    animation: '$pulse 1.5s ease-in alternate infinite'
  },
  avatar: {
    animation: '$pulse 1.5s ease-in alternate infinite'
  },
  '@keyframes pulse': {
    '0%': {
      opacity: 0.1
    },
    '100%': {
      opacity: 0.9
    }
  }
});
